import InputField from '../../../components/Forms/Input/InputField';

interface Props {
  form: any;
  formErrors: Record<string, string>;
  updateField: (name: string, value: any) => void;
}

const ImportPurchaseFields: React.FC<Props> = ({ form, formErrors, updateField }) => {
  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <InputField
        label="Monto Neto"
        name="netAmount"
        iconKey="dollar"
        type="number"
        value={form.netAmount || ''}
        onChange={(e) => updateField('netAmount', Number(e.target.value))}
        error={formErrors.netAmount}
        min={0}
        step={'0.01'}
        required
      />
      <InputField
        label="Flete"
        name="freight"
        iconKey="truck"
        type="number"
        value={form.freight || ''}
        onChange={(e) => updateField('freight', Number(e.target.value))}
        error={formErrors.freight}
        min={0}
        step={'0.01'}
        required
      />
      <InputField
        label="Seguro"
        name="insurance"
        iconKey="security"
        type="number"
        value={form.insurance || ''}
        onChange={(e) => updateField('insurance', Number(e.target.value))}
        error={formErrors.insurance}
        min={0}
        step={'0.01'}
        required
      />
      <InputField
        label="FAUCA"
        name="fauca"
        iconKey="document"
        type="number"
        value={form.fauca || ''}
        onChange={(e) => updateField('fauca', Number(e.target.value))}
        error={formErrors.fauca}
        min={0}
        step={'0.01'}
        required
      />
      <InputField
        label="Otros Costos"
        name="otherCosts"
        iconKey="more"
        type="number"
        value={form.otherCosts || ''}
        onChange={(e) => updateField('otherCosts', Number(e.target.value))}
        error={formErrors.otherCosts}
        min={0}
        step={'0.01'}
      />
    </div>
  );
};

export default ImportPurchaseFields;
